module.exports = "/_next/static/images/dock-01ac98e97d366f2b92687e5d90465161.png";